import { render, staticRenderFns } from "./question-card.vue?vue&type=template&id=7a6263b4"
import script from "./question-card.ts?vue&type=script&lang=ts&external"
export * from "./question-card.ts?vue&type=script&lang=ts&external"
import style0 from "./question-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports